/**
 * @module modules/commit-detail-panel-sk
 * @description <h2><code>commit-detail-panel-sk</code></h2>
 *
 * @evt commit-selected - Event produced when a commit is selected. The
 *     the event detail contains the serialized cid.CommitDetail and
 *     a simplified description of the commit:
 *
 *     <pre>
 *     {
 *       selected: 2,
 *       description: "foo (foo@example.org) 62W Commit from foo.",
 *       commit: {
 *         author: "foo (foo@example.org)",
 *         url: "skia.googlesource.com/bar",
 *         message: "Commit from foo.",
 *         ts: 1439649751,
 *       },
 *     }
 *     </pre>
 *
 * @attr {Boolean} selectable - A boolean attribute that if true means
 *     that the commits are selectable, and when selected
 *     the 'commit-selected' event is generated.
 *
 * @attr {Number} selected - The index of the selected commit.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CommitDetailPanelSk", {
    enumerable: true,
    get: function() {
        return CommitDetailPanelSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _dom = require("../../../infra-sk/modules/dom");
require("../commit-detail-sk");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let CommitDetailPanelSk = class CommitDetailPanelSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    renderRows() {
        if (this.hide) {
            return [
                (0, _lit.html)``
            ];
        }
        return this.details.map((item, index)=>(0, _lit.html)`
        <tr data-id="${index}" ?selected="${this._isSelected(index)}">
          <td>
            <commit-detail-sk .cid=${item} .trace_id=${this.trace_id}></commit-detail-sk>
          </td>
        </tr>
      `);
    }
    render() {
        return (0, _lit.html)`
      <table @click=${this._click}>
        ${this.renderRows()}
      </table>
    `;
    }
    _isSelected(index) {
        return this.selectable && index === this.selected;
    }
    _click(e) {
        if (!this.selectable) {
            return;
        }
        const ele = (0, _dom.findParent)(e.target, 'TR');
        if (!ele) {
            return;
        }
        this.selected = +(ele.dataset.id || '0');
        if (this.selected > this.details.length - 1) {
            return;
        }
        const commit = this.details[this.selected];
        const detail = {
            selected: this.selected,
            description: `${commit.author} -  ${commit.message}`,
            commit
        };
        this.dispatchEvent(new CustomEvent('commit-selected', {
            detail,
            bubbles: true
        }));
    }
    constructor(...args){
        super(...args);
        this.details = [];
        this.hide = false;
        this.trace_id = '';
        this.selectable = false;
        this.selected = -1;
    }
};
_ts_decorate([
    (0, _decorators.property)({
        type: Array
    }),
    _ts_metadata("design:type", Array)
], CommitDetailPanelSk.prototype, "details", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    _ts_metadata("design:type", Boolean)
], CommitDetailPanelSk.prototype, "hide", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    }),
    _ts_metadata("design:type", String)
], CommitDetailPanelSk.prototype, "trace_id", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean,
        reflect: true
    }),
    _ts_metadata("design:type", Boolean)
], CommitDetailPanelSk.prototype, "selectable", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number,
        reflect: true
    }),
    _ts_metadata("design:type", Number)
], CommitDetailPanelSk.prototype, "selected", void 0);
CommitDetailPanelSk = _ts_decorate([
    (0, _decorators.customElement)('commit-detail-panel-sk')
], CommitDetailPanelSk);
